import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DiagramService from "../../../../../services/diagrams/DiagramService";
import Diagram from "../mesocycle/diagrams/Diagram";
import "react-tabs/style/react-tabs.css";

interface ExerciseStatsDto {
  orderId: number;
  category: string;
  repetitions: number;
  sets: number;
}

interface ExerciseStatsForMesocycleDto {
  mesocycleId: string;
  label: string | null;
  orderId: number;
  exerciseStatsDtoList: ExerciseStatsDto[];
}

interface StatisticsProps {
  programId: string;
}

const Statistics: React.FC<StatisticsProps> = ({ programId }) => {
  const [data, setData] = useState<ExerciseStatsForMesocycleDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await DiagramService.getExerciseStatsByProgramId(programId);
        setData(response.data);
      } catch (err) {
        console.error("Failed to load exercise stats", err);
        setError("Failed to load statistics");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, [programId]);

  if (isLoading) return <p>Loading statistics...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (data.length === 0) return <p>No statistics available.</p>;

  return (
    <Tabs>
      <TabList>
        {data.map((mesocycle, index) => (
          <Tab key={mesocycle.mesocycleId}>
            {mesocycle.label || `Mesocycle ${index + 1}`}
          </Tab>
        ))}
      </TabList>

      {data.map((mesocycle) => (
        <TabPanel key={mesocycle.mesocycleId}>
          <Diagram mesocycleId={mesocycle.mesocycleId} />
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default Statistics;
